import { countriesEN, type Country } from "@/assets/locales/en/countries-en";

const japaneseRegionNames = new Intl.DisplayNames(["ja"], { type: "region" });

export const countriesJA: Country[] = countriesEN.map(({ value, label }) => ({
  value,
  label: japaneseRegionNames.of(value) ?? label,
}));